<template>
  <div>











  </div>
</template>

<script>
    export default {
        name: 'body_atas',
            data () {
            return {
                msg: 'monev_left_sidebar',
                apakah: 'Telasomu'
            }
        }
    }
</script>

<style>

</style>
